<template>
  <!--<h3>获取密码记录</h3>-->
  <div>
    <search-list :projectList="projectList" :pwdStatusList="pwdStatusList" :pwdTypeList="pwdTypeList"
                 :userTypeList="userTypeList" @findData="findData" :setDefault="setDefault"></search-list>
    <div class="page-wrapper">
      <table-list
       
        :columns="columns"
        :data="data"
        :loading="loading"
        @change-page="changePage"
        :total="total"
        :current="current"
      >
      </table-list>
    </div>
  </div>

</template>

<script type="text/ecmascript-6">
  import SearchList from './components/SearchList';
  import TableList from 'components/TableList/index';
  import {getProjects} from "api/common";
  import {getPwdType, getPwdStatus, getUserType, getPwdLogList} from 'api/passwordRecord'

  export default {
    name: 'psdrecord',
    components: {
      SearchList,
      TableList
    },
    data() {
      return {
        columns: [
          {
            type: 'index',
            key: 'index',
            width: 60,
            align: 'center',
          },
          {
            title: '获取状态',
            key: 'pwdStatus',
            align: 'center',
            render: (h, params) => {
              return h('span', {}, this.pwdStatusMap[params.row['pwdStatus'] + ''])
            }
          },
          {
            title: '密码类型',
            key: 'pwdType',
            align: 'center',
            render: (h, params) => {
              return h('span', {}, this.pwdTypeListMap[params.row['pwdType'] + ''])
            }
          },
          {
            title: '项目',
            key: 'projectName',
            align: 'center'
          },
          {
            title: '房间信息',
            key: 'roomInfo',
            align: 'center',
            render: (h, params) => {
              return h('span', {}, params.row['buildingName'] + '-' + params.row['floorNumber'] + '-' + params.row['roomNumber'])
            }
          },
          {
            title: '操作时间',
            key: 'createTime',
            align: 'center',
          },
          {
            title: '操作人',
            key: 'handlerName',
            align: 'center'
          },
          {
            title: '使用人类型',
            key: 'userType',
            align: 'center',
            render: (h, params) => {
              return h('span', {}, this.userTypeMap[params.row['userType'] + ''])
            }
          },
          {
            title: '使用人',
            key: 'userName',
            align: 'center'
          },
          {
            title: '使用人手机',
            key: 'userPhone',
            align: 'center'
          },
          {
            title: '生效时间',
            key: 'startTime',
            align: 'center'
          },
          {
            title: '失效时间',
            key: 'endTime',
            align: 'center'
          }
        ],
        data: [],
        total: 0,
        current: 1,
        loading: false,
        projectList: [],
        pwdStatusList: [],
        pwdTypeList: [],
        userTypeList: [],
        searchData: null,
        setDefault:false,
      }
    },
    computed: {
      pwdStatusMap() {
        var ret = {}
        this.pwdStatusList.forEach(ele => {
          ret[ele.value + ''] = ele.text
        })
        return ret
      },
      pwdTypeListMap() {
        var ret = {}
        this.pwdTypeList.forEach(ele => {
          ret[ele.value + ''] = ele.text
        })
        return ret
      },
      userTypeMap(){
        var ret={}
        this.userTypeList.forEach(ele=>{
          ret[ele.value + ''] = ele.text
        })
        return ret
      }
    },
    created() {
      getProjects().then(res => {
        if(!res.data){
          return
        }
        this.projectList = res.data
        this.projectList.length>0&&(this.setDefault=true)
      })
      getPwdStatus().then(res => {
        res.data &&( this.pwdStatusList = res.data)
      })
      getPwdType().then(res => {
        res.data && ( this.pwdTypeList = res.data)
      })
      getUserType().then(res => {
        res.data &&(this.userTypeList = res.data)
      })
    },
    methods: {
      findData(params) {
        this.searchData = Object.assign({}, params)
        this.initList()
      },
      initList() {
        getPwdLogList(this.searchData).then(res => {
          this.data = res.data.rows
          this.total = res.data.total;
        })
      },
      changePage(n) {
        this.current = n;
        if (this.searchData !== null) {
          this.searchData.page = n
          this.initList(this.searchData)
        }
      },
    }

  }
</script>

<style lang="css" scoped>

</style>
